// extracted by mini-css-extract-plugin
export default {"Login":"AuthForm_Login__M0iaE","Signup":"AuthForm_Signup__T291k","linkControl":"AuthForm_linkControl__mA1RF","redirect-text":"AuthForm_redirect-text__qCkD9"};